import { format } from 'date-fns/format'
import { isToday } from 'date-fns/isToday'
import { parse } from 'date-fns/parse'

const timeFormat = 'h aaa'
const dateFormat = 'yyyy-MM-dd'

export function parseChartEntryDate(date: string) {
  const formats = [timeFormat, dateFormat]

  for (const format of formats) {
    const parsed = parse(date, format, new Date())

    if (!isNaN(parsed.getTime())) {
      return parsed
    }
  }

  return new Date()
}

export function formatChartEntryDate(date: Date) {
  return isToday(date) ? format(date, timeFormat) : format(date, dateFormat)
}
